export const PAYMENT_IDENTIFICATION_METHOD = 'identificationMethod';
export const PAYMENT_IDENTIFICATION_NUMBER = 'identificationNumber';
export const CURRENCIES_NOT_SUPPORTING_VAULT = ['BRL', 'ARS', 'MXN'];
